import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { Apiurl } from "../../../util/apiurl";
import axiosInstance from "../../../util/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

function SignUp() {
  const { id, topic } = useParams();

  const navigate = useNavigate();

  const [isHuman, setIsHuman] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [agreedToStatement, setAgreedToStatement] = useState(true);
  const [captchaValue, setCaptchaValue] = useState("");
  const [error, setError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleRecaptchaChange = (value) => {
    if (value) {
      setIsHuman(true);
      setCaptchaValue(value);
    } else {
      setIsHuman(false);
      setCaptchaValue("");
    }
  };

  const validateMobileNumber = (number) => {
    if (number.length < 10) {
      setMobileError("Enter a valid 10 digit number");
      return false;
    }
    if (number.length === 10 && number.startsWith("0")) {
      setMobileError("10-digit mobile numbers should not start with 0.");
      return false;
    }
    if (number.startsWith("1")) {
      setMobileError("10-digit mobile numbers should not start with 1.");
      return false;
    }
    if (number.startsWith("2")) {
      setMobileError("10-digit mobile numbers should not start with 2.");
      return false;
    }
    if (number.startsWith("3")) {
      setMobileError("10-digit mobile numbers should not start with 3.");
      return false;
    }
    if (number.startsWith("4")) {
      setMobileError("10-digit mobile numbers should not start with 4.");
      return false;
    }
    if (number.startsWith("5")) {
      setMobileError("10-digit mobile numbers should not start with 5.");
      return false;
    }
    if (number.length === 10) {
      number = number;
      setMobileNumber(number);
    }
    setMobileError(""); // Clear mobile number error
    return true;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return false;
    }
    setEmailError(""); // Clear email error
    return true;
  };

  const handleSignup = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!username || !email) {
      setError("Full Name and Email are required.");
      return;
    }
    if (!validateEmail(email)) {
      return;
    }
    if (mobileNumber && !validateMobileNumber(mobileNumber)) {
      return;
    }
    if (!isHuman) {
      setError("Please confirm you are not a robot.");
      return;
    }

    setError(""); // Clear error if validation passes

    const totalMarks = localStorage.getItem("totalMarks") || 0; // Retrieve totalMarks from localStorage
    const timeTaken = localStorage.getItem("quizSubmissionTime") || 300;
    const payload = {
      username,
      email,
      mobileNumber,
      agreedToStatement,
      topicId: id, // Example topicId, replace with appropriate value
      score: Number(totalMarks),
      timeTaken: Number(timeTaken),
      notARobot: isHuman ? true : false,
    };

    try {
      const response = await axiosInstance.post(Apiurl.signUpForm, payload); // Replace with your actual API endpoint
      console.log("Submit response: ", response.data);
      // Handle response or redirect as needed

      // Navigate to /homepage after 3 seconds
      setTimeout(() => {
        navigate(`/QuizRank/${id}/${topic}`);
      }, 1000);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message); // Display the error message from the API
      } else {
        setError("User already exists, please login.");
      }
      console.error("Error submitting form: ", error.response.data);
    }
  };

  const handleSign = () => {
    navigate(`/LogInQuiz/${id}/${topic}`);
  };

  return (
    <>
      <div className="form-main-conatiner">
        <h2>Join to see your leaderboard rank!</h2>
        <form onSubmit={handleSignup}>
          <div className="input-div">
            <label>
              Full Name <span>*</span>
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-div">
            <label>
              Email <span>*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {emailError && <div className="error-message">{emailError}</div>}
          </div>
          <div className="input-div phone-div">
            <label>Mobile Number</label>
            <span className="no-code">+91</span>
            <input
              type="text"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
            {mobileError && <div className="error-message">{mobileError}</div>}
          </div>
          <div className="check-div">
            <input
              type="checkbox"
              checked={agreedToStatement}
              onChange={() => setAgreedToStatement(!agreedToStatement)}
            />
            By registering, you agree to receive occasional emails from Finlabs with valuable resources and updates.
          </div>
          <div className="captcha">
            <ReCAPTCHA
              sitekey="6LeG_FspAAAAALyvbGtWVycZfdoWT4adxVMGQiQO"
              onChange={handleRecaptchaChange}
            />
            {isHuman ? (
              <p>Thank you for confirming you are human.</p>
            ) : (
              <p>Please confirm you are not a robot.</p>
            )}
          </div>
          {error && <div className="error-message">{error}</div>}
          <div className="btn-sec">
            <button type="submit" className="sign-up-btn">
              Sign up
            </button>
          </div>
          <div>
            Already a user?{" "}
            <button className="log-signup-txt" onClick={handleSign}>
              Log In
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default SignUp;
